import { getGlobalImpTransactions, getGlobalTransactionSummary, getGlobalTransactions } from "../types/global_transactions_types";

const initState = {
    transactions: {
        data: [],
        count: 0,
        loading: false
    },
    impTransactions: {
        data: [],
        count: 0,
        loading: false
    },
    summary: {
        data: [],
        count: 0,
        loading: false
    }
};

export default function getGlobalTransactionsReducers(state = initState, action = {}) {
    switch (action.type) {
        case getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_REQUEST:
            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    loading: true
                }

            };
        case getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                }
            };
        case getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_ERROR:
            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    loading: false
                }
            };
        case getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_REQUEST:
            return {
                ...state,
                impTransactions: {
                    ...state.impTransactions,
                    loading: true
                }

            };
        case getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                impTransactions: {
                    ...state.impTransactions,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                }
            };
        case getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_ERROR:
            return {
                ...state,
                impTransactions: {
                    ...state.impTransactions,
                    loading: false
                }
            };
        case getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_REQUEST:
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: true
                }

            };
        case getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                }
            };
        case getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_ERROR:
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: false
                }
            };

        default:
            return state;
    }
}
